// web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyDOP-uqvdoKJIHlBBbUoyVQehVGQD0SA24",
    authDomain: "tour-planner-project.firebaseapp.com",
    projectId: "tour-planner-project",
    storageBucket: "tour-planner-project.appspot.com",
    messagingSenderId: "71444173463",
    appId: "1:71444173463:web:42f7c68a0bc35426744fd2"
  };

  export default firebaseConfig;